module.exports = __webpack_public_path__ + "static/icons/icon-chevron-right-9d50596faf918e662a92df89520b8006.svg";